export default {
  scene: {
    background: 0xffbc8d,
    fog: {
      color: 0xffbc8d,
      near: 20,
      far: 100
    }
  },
  camera: {
    from: {
      x: 0,
      y: 100,
      z: 500
    },
    to: {
      x: 0,
      y: 8,
      z: 54
    }
  }
}
